import { useDispatch, useSelector } from 'react-redux';
import { SetPageNumber, SetPageSize, SetTextField } from '../../stores/sellers/actions';

const useSearchParameters = () => {
    const { pageSize, pageNumber, textField, totalResults, totalPage } = useSelector(state => state.sellers_data);
    const dispatch = useDispatch();

    const replacePageNumber = (pageNumber) => {
        if(pageNumber < 1)
            pageNumber = 1;

        dispatch(SetPageNumber(pageNumber));
    }

    const replacePageSize = (pageSize) => {
        if(pageSize < 1)
            pageSize = 1;

        dispatch(SetPageSize(pageSize));
    }

    const setTextField = (textField) => 
        dispatch(SetTextField(textField))

    return { 
        pageSize, 
        pageNumber,
        totalResults,
        totalPage,
        textField,
        replacePageNumber,
        replacePageSize,
        setTextField,
    }
}

export default useSearchParameters;